import { ITagsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class AddTagsToPublishedConnectionsRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    super('addTagsToPublishedConnections', {
      ids: ids,
      tags: tags
    });
  }
}
